module.exports = __webpack_public_path__ + "static/img/img-features-feature-5-accessibility_ja.b8b0542.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-5-accessibility_ja.png
// module id = jLIM
// module chunks = 18